// Shared genre pill coloring, used by the pitch page tiles and the media kit.
// The gradient for each class is defined once as --genre-color-0..7 in styles.css.

// Pinned colors for known genres; anything else hashes to a palette slot
const pinnedGenreColors: Record<string, number> = {
  food: 0,  // light blue
  pets: 2,  // pink
};

export function genreColorClass(tag: string): string {
  const normalized = tag.toLowerCase();
  const pinned = pinnedGenreColors[normalized];
  if (pinned !== undefined) return 'genre-color-' + pinned;
  let hash = 0;
  for (let i = 0; i < normalized.length; i++) {
    hash = (hash * 31 + normalized.charCodeAt(i)) | 0;
  }
  return 'genre-color-' + (Math.abs(hash) % 8);
}
